import React, { useEffect, useRef, useState } from "react";
import { AiOutlineClose } from "react-icons/ai";
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from "react-icons/md";
import profile_Img from "../../../../../../../Assets/Images/user.png";

const SelectedChatAvatars = ({ selectedChats, handleRemoveSelected }) => {
  const [startIndex, setStartIndex] = useState(0);
  const [showArrows, setShowArrows] = useState(false);
  const visibleCount = 5;

  useEffect(() => {
    setShowArrows(selectedChats.length > visibleCount);
  }, [selectedChats]);

  const handlePrev = () => {
    if (startIndex > 0) setStartIndex(startIndex - 1);
  };

  const handleNext = () => {
    if (startIndex + visibleCount < selectedChats.length) {
      setStartIndex(startIndex + 1);
    }
  };

  return (
    <div className="flex items-center gap-2">
      {showArrows && (
        <button onClick={handlePrev} disabled={startIndex === 0}>
          <MdKeyboardArrowLeft size={24} />
        </button>
      )}
      <div className="flex overflow-hidden gap-2 w-[340px]">
        {selectedChats
          .slice(startIndex, startIndex + visibleCount)
          .map((chat) => (
            <div className="py-4">
              <div
                key={chat._id}
                className="relative flex flex-col items-center"
              >
                <img
                  src={chat.avtarImage || chat.userImage || chat.mediaId?.imageUrl || profile_Img}
                  alt={chat.name}
                  className="w-[40px] h-[40px] rounded-full border-2 border-gray-300"
                />
                <button
                  onClick={() => handleRemoveSelected(chat._id)}
                  className="absolute -top-1.5 -right-[-8px] bg-white text-[#7C7C7C] group hover:bg-primary border border-[#7C7C7C] text-xs rounded-full w-4 h-4 flex items-center justify-center"
                >
                  <AiOutlineClose
                    size={10}
                    className="group-hover:text-white"
                  />
                </button>
                <span className="text-xs text-gray-700 mt-1 truncate w-14">
                  {chat.name}
                </span>
              </div>
            </div>
          ))}
      </div>
      {showArrows && (
        <button
          onClick={handleNext}
          disabled={startIndex + visibleCount >= selectedChats.length}
        >
          <MdKeyboardArrowRight size={24} />
        </button>
      )}
    </div>
  );
};

export default SelectedChatAvatars;
